import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const PeppolRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--peppol']}>
    <Route index element={<Index />} />
  </SubRouter>
))
